import React, { useCallback } from "react";
import { useAttributes } from "shared/hooks/use-attributes";
import * as notify from "shared/notify";
import AttributeControls from "./attribute-controls";

export const AttributeTitle = ({
    attr,
    addAttribute,
    removeAttribute,
    isCompleted,
    title,
    tooltip,
    isReadOnlyAdd,
    isReadOnlyDelete,
    isBrandVerified,
    isQa,
}) => {
    const { data, add, remove } = useAttributes();

    const handleRemoveAttribute = useCallback(
        async (e) => {
            e.preventDefault();
            const confirm = await notify.confirm("Are you sure you want to delete this attribute?");

            if (confirm) {
                remove(attr.uuid, () => {
                    // should be called only when 'refresh' is needed
                    removeAttribute(attr);
                });
            }
        },
        [removeAttribute, remove, attr]
    );

    const handleAddAttribute = useCallback(
        (e) => {
            e.preventDefault();
            add(attr);
        },
        [add, attr]
    );

    return (
        <div className="row-header">
            <span>{title}</span>
            <AttributeControls
                tooltip={tooltip || attr.tooltip}
                containsUuid={data.hasOwnProperty(attr.uuid)}
                completed={isCompleted}
                readOnly={attr.readOnly}
                required={attr.required}
                onAddAttribute={addAttribute || handleAddAttribute}
                onRemoveAttribute={handleRemoveAttribute}
                isReadOnlyAdd={isReadOnlyAdd}
                isReadOnlyDelete={isReadOnlyDelete}
                readonlyOnTaskType={attr.readonlyOnTaskType}
                isBrandVerified={isBrandVerified}
                isQa={isQa}
            />
        </div>
    );
};
